'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LegalStatement = function (_Component) {
  (0, _inherits3.default)(LegalStatement, _Component);

  function LegalStatement() {
    (0, _classCallCheck3.default)(this, LegalStatement);
    return (0, _possibleConstructorReturn3.default)(this, (0, _getPrototypeOf2.default)(LegalStatement).call(this));
  }

  (0, _createClass3.default)(LegalStatement, [{
    key: 'render',
    value: function render() {
      var styles = require('./LegalStatement.scss');
      return _react2.default.createElement(
        'div',
        { className: styles.component },
        _react2.default.createElement(
          'div',
          { className: styles.tactTitle },
          '法律声明'
        ),
        _react2.default.createElement('div', { className: styles.tactLink }),
        _react2.default.createElement(
          'div',
          { className: styles.tactTxt },
          _react2.default.createElement(
            'h2',
            null,
            '一、信息发布'
          ),
          _react2.default.createElement(
            'p',
            null,
            '由于本平台提供的网络服务关系到您的交易安全，关系到每个会员（含商城经营者和用户）的合法权益。为保证交易安全，您确认同意： '
          ),
          _react2.default.createElement(
            'p',
            null,
            '1、您提供的注册信息及其他在艺品网平台上发布的任何信息均是真实、准确、完整、合法有效的；'
          ),
          _react2.default.createElement(
            'p',
            null,
            '2、您提供的注册资料如发生变化，请务必及时在本平台进行更新；'
          ),
          _react2.default.createElement(
            'p',
            null,
            '3、本平台可能会不定期的将交易资讯、行业资讯、促销活动等通过电子邮件或通讯软件等方式通知您。且您在本平台注册后，视为您同意接受本平台以电子邮件或通讯软件等方式的通知。'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '二、隐私权政策 '
          ),
          _react2.default.createElement(
            'p',
            null,
            '1、尊重会员隐私是艺品网平台的一项基本政策。为了给您提供更准确、更优质的服务，本平台会按照本隐私权政策的规定对您提供的信息采取保密措施。'
          ),
          _react2.default.createElement(
            'p',
            null,
            '2、您向本平台提供的信息受到本平台的保护，但如果存在以下情况，艺品网平台将披露您的信息：'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childContent },
            '①征得您的同意；'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childContent },
            '②您对自身信息保密不当原因，导致您非公开信息泄露；'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childContent },
            '③由于网络线路、黑客攻击、计算机病毒、政府管制等原因造成的信息泄露、丢失、被盗用或被篡改等；'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childContent },
            '④根据法律法规的有关规定，或者行政或司法机构的要求，向第三方或者行政、司法机构披露；'
          ),
          _react2.default.createElement(
            'div',
            { className: styles.childContent },
            '⑤因您违反法律法规、或者艺品网平台服务协议或其他规定的情况，需要向第三方披露。'
          ),
          _react2.default.createElement(
            'p',
            null,
            '3、虽然本平台对您的信息、密码等采取了安全保护措施，确保您的信息不丢失，不被滥用和变造。但是请您注意在信息网络上不存在“完善的安全措施”，所以请您妥善保管您的账户及密码信息。如您发现您的账户、密码已经泄露或存在风险，请您立即联系本平台的客户，以便本平台采取相应的措施。'
          ),
          _react2.default.createElement(
            'h2',
            null,
            '三、权利声明 '
          ),
          _react2.default.createElement(
            'p',
            null,
            '对于本网站中所含的知识产权和其他权利，您应当予以尊重。如果内容未含权利声明，并不代表本网站对其不享有权利和不主张权利，您应根据法律、法规及诚实信用原则尊重权利人的合法权益并合法使用该内容。未经本平台许可，任何人不得擅自（包括但不限于：以非法的方式复制、传播、展示、下载）使用。否则，艺品网平台运营者将依法追究您的法律责任。'
          )
        )
      );
    }
  }]);
  return LegalStatement;
}(_react.Component); /**
                      * Created by zfc on 2016/9/13.
                      */
/**
 * Created by zfc on 2016/9/13.
 */


exports.default = LegalStatement;
module.exports = exports['default'];


/*****************
 ** WEBPACK FOOTER
 ** ./src/containers/LegalStatement/LegalStatement.js
 ** module id = 1490
 ** module chunks = 0
 **/